module.exports = "/_next/static/images/e6e02f04b7808e622450e3a0d9d311b1-warning_circle.svg";